/*global $ */

import * as dropdownPopup from './holiday24/components/dropdown-popup';
import * as periodPicker from './holiday24/components/period-picker';
import * as personsPicker from './holiday24/components/persons-picker';
import * as weatherStation from './holiday24/components/weather-station';
import * as weatherChart from './holiday24/components/weather-chart';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/collapse';
import 'jquery.scrollto';
import 'slick-carousel';

dropdownPopup.registerComponent();
periodPicker.registerComponent();
personsPicker.registerComponent();
weatherStation.registerComponent();
weatherChart.registerComponent();

function setHorizontalNavOffset() {
  window.horizontalNavOffset = $('body .page-header').css('position') === 'sticky' ? 107 : 44;
}

setHorizontalNavOffset();

function horizontalNavClick(e) {
  $(window).scrollTo($(e.currentTarget).attr('href'), 500, { offset: 1 - window.horizontalNavOffset });
  return false;
}

$('body').scrollspy({ target: '#horizontal-nav', offset: window.horizontalNavOffset });
$('body').on('click', '#horizontal-nav a, .js-no_ratings-link', horizontalNavClick);

$('.teaser_carousel_element').slick({
  autoplay: !0,
  dots: !1,
  prevArrow: '<button type="button" class="carousel-control-prev-icon">Vorherige</button>',
  nextArrow: '<button type="button" class="carousel-control-next-icon">Nächste</button>',
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [{ breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } }],
});

$(window).on('load', function () {
  var $nav = $('#horizontal-nav');
  if ($nav.length) {
    var $body = $('body');

    function fixOffset() {
      var data = $body.data('bs.scrollspy');
      if (data) {
        setHorizontalNavOffset();
        data._config.offset = window.horizontalNavOffset;
        $body.data('bs.scrollspy', data);
        $body.scrollspy('refresh');
      }
    }

    var resizeTimer;
    $(window).resize(function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fixOffset, 200);
    });
  }
});
